import { FormHTMLAttributes, InputHTMLAttributes } from 'react'
import { Search as SearchIcon } from 'lucide-react'

import Spinner from './spinner'
import { cn } from '@/lib/utils'

export type SearchProps = Omit<FormHTMLAttributes<HTMLFormElement>, 'onChange'> &
  Pick<InputHTMLAttributes<HTMLInputElement>, 'onChange'> &
  Partial<{
    placeholder: string
    fetching: boolean
  }>

const Search = ({ placeholder, className, fetching, onChange, ...props }: SearchProps) => {
  return (
    <form
      className={cn(
        'flex min-h-[4.4rem] min-w-[15rem] items-center justify-center space-x-[1.5rem] rounded-[0.5rem] px-[2.4rem] py-[1.2rem]',
        'border border-dark/25 bg-white',
        'focus-within-input-ring-dark',
        className
      )}
      {...props}
    >
      <input
        id="search"
        type="text"
        name="search"
        onChange={onChange}
        placeholder={placeholder || 'Cerca'}
        aria-label={placeholder || 'Cerca'}
        className={cn(
          'font-helvetica text-breadcrumbs font-bold',
          'text-dark placeholder:text-dark',
          'w-[8.2rem] grow outline-none'
        )}
      />
      <button type="submit" aria-label="Cerca" className="group inline-flex outline-none">
        <span
          className={cn(
            '-m-2 rounded-md p-2',
            'group-focus-visible:ring-2 group-focus-visible:ring-[var(--focus-ring-dark)]'
          )}
        >
          {fetching ? (
            <Spinner variant="small" />
          ) : (
            <SearchIcon size={16} strokeWidth="2.5" className="stroke-dark" />
          )}
        </span>
      </button>
    </form>
  )
}

export default Search
